import { render, staticRenderFns } from "./CloseIcon.vue?vue&type=template&id=7e6dc81e"
var script = {}


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports